/**
 * @external L.Draggable
 * 
 * @see https://github.com/Leaflet/Leaflet/tree/v1.9.3/src/dom/Draggable.js
 */

/**
 * A class for making DOM elements draggable (including touch support).
 * Used internally for map and marker dragging. Only works for elements
 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
 */

L.Draggable.include({

    /** @TODO */
    // updateMapBearing: function(mapBearing) {
    //     this._mapBearing = mapBearing;
    // },

});